import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { get } from '../../../utils/api';
import style from './MobileProductDetailPage.module.css'

const MobileProductDetailPage = () => {

  const SERVER_URL = "https://sensetab.co.kr/";
  const [product, setProduct] = useState([]);
  const [prdImg, setPrdImg] = useState([]);
  let {idx} = useParams();
  
  
  useEffect(() => {
    
    const prdData = async () => {
      try {
        await get(
          '/product/detail',
          {
            idx : idx,
            type : 'M',
          }
          )
        .then((response) => {
          setProduct(response[0]);
          setPrdImg(response[1].imgs);
        });  
      } catch (error) {
        console.log(error);  
      };
    };
    prdData();
    
  }, [idx]);

  return (
    <>
      <div>
        {prdImg.map((imgs) => (
          <img key={imgs.PRD_IMG_IDX} className={style.detailPrdImg}  src={SERVER_URL + imgs.PRD_IMG_PATH} alt={product.PRD_NAME} />
        ))}
      </div>
    </>
  );

};

export default MobileProductDetailPage;
